import { ShieldCheck } from "lucide-react";

export const SecureCodingTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl border border-primary/20 p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center shrink-0">
          <ShieldCheck className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
          <p className="text-muted-foreground leading-relaxed">
            Security isn't a feature you add at the end — it's a mindset you apply from the first line of code. 
            70% of vulnerabilities are preventable with basic secure coding practices. Understanding the OWASP 
            Top 10 isn't optional; it's the minimum every developer should know.
          </p>
        </div>
      </div>
    </div>
  );
};
